import{runningOnBrowser as s}from"./environment.js";const o=(o,t)=>{s&&""!==t&&o.classList.add(t)},t=(o,t)=>{s&&""!==t&&o.classList.remove(t)};export{o as addClass,t as removeClass};
